export enum EFormStatus {
  Todo = 1,
  InProgress = 2,
  Submitted = 3,
}
